const translations = {
    description: 'Description',
    item: 'Item',
    total: 'Total'
};

export default translations;
